document.addEventListener('DOMContentLoaded', function() {
    var filtersNavs = document.querySelectorAll('[data-filters]')

    for (let i = 0; i < filtersNavs.length; i++) {
        var filtersNav = filtersNavs[i],
            filtersLinks = filtersNav.children
        
        for (let i = 0; i < filtersLinks.length; i++) {
            var filter = filtersLinks[i]

            filter.addEventListener('click', function(event) {
                event.preventDefault()
                var activeFilter = this.parentElement.querySelector('.active'),
                    elements = this.parentElement.nextElementSibling.children

                if (this != activeFilter) {
                    activeFilter.classList.remove('active')
                    this.classList.add('active')

                    var toSortId = this.getAttribute('id')
                    
                    for (let i = 0; i < elements.length; i++) {
                        var element = elements[i]
                        element.style.transform = 'scale(0)'
                    }
                    window.setTimeout(function() {
                        for (let i = 0; i < elements.length; i++) {
                            let element = elements[i]
                            if (element.classList.contains(toSortId) == false && toSortId != 'all') {
                                element.style.display = 'none'
                            } else {
                                element.style.display = 'block'
                            }
                        }
                    }, 200)
                    window.setTimeout(function() {
                        for (let i = 0; i < elements.length; i++) {
                            let element = elements[i]
                            if (toSortId == 'all' || element.classList.contains(toSortId)) {
                                element.style.transform = 'scale(1)'
                            }
                        }
                    }, 400)
                }
            })
        }
    }
})
